<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :showList="true"
            :cols="cols"
            @click:row="setItem"
            api-url="product/product/all"
            :show-submit-and-clear-btn="false"
            :show-list-btn="false"
            :canDelete="false"
            :items="items"
            :canSubmit="canSubmit"
            :isEditing.sync="isEditing"
            :show-navigation-btns="false"
            @submit="submit"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="productForm"
        >
          <template v-if="isXs">
            <v-row v-if="item.id">
              <v-col cols="12">
                <v-avatar v-if="!item.picture" size="100" class="rounded-lg mr-4" color="#FFACC5">
                  <v-img
                      @click="change_picture_dialog = true"
                      style="cursor: pointer"
                      contain
                      max-height="90"
                      max-width="90"
                      src="/img/icons/product.svg"
                  />
                </v-avatar>
                <v-avatar class="mr-2" v-if="item.picture" size="100" style="cursor: pointer"
                          @click="change_picture_dialog = true">
                  <v-img class="rounded-lg" :src="item.picture"/>
                </v-avatar>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field label="نام محصول "
                              v-model="item.name" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>

              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field label="شناسه محصول "
                              v-model="item.product_id" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <currency-select
                    class="rounded-lg"
                    label="ارز"
                    v-model="item.currency"
                    :disabled="!isEditing"
                >
                </currency-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field label="کد قفسه "
                              v-model="item.shelf_code" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <money label="موجودی اولیه "
                       v-model="item.first_inventory" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <money label="قیمت "
                       v-model="item.price" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <money label="حاشیه سود "
                       v-model="item.profit_percent" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <money label="حداقل موجودی "
                       v-model="item.min_inventory" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <money label="هزینه حمل و نقل "
                       v-model="item.shipping_cost" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <money label="درصد مالیات "
                       v-model="item.tax_percent" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <category-select
                    class="rounded-lg"
                    label="دسته بندی"
                    v-model="item.category"
                    :disabled="!isEditing"
                ></category-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <supplier-select
                    class="rounded-lg"
                    label="تامین کننده"
                    v-model="item.supplier"
                    :disabled="!isEditing"
                >
                </supplier-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <brand-select
                    class="rounded-lg"
                    label="برند کالا"
                    v-model="item.brand"
                    :disabled="!isEditing"
                ></brand-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <date
                    class="rounded-lg"
                    label="تاریخ تولید"
                    v-model="item.product_date"
                    :disabled="!isEditing"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <date
                    class="rounded-lg"
                    label="تاریخ انقضا"
                    v-model="item.expired_date"
                    :disabled="!isEditing"

                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                    class="rounded-lg"
                    label="توضیحات مختصر"
                    v-model="item.summary_explanation"
                    :disabled="!isEditing"
                    rows="2"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                    class="rounded-lg"
                    label="نحوه استفاده"
                    v-model="item.how_to_use"
                    :disabled="!isEditing"
                    rows="2"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                    class="rounded-lg"
                    label="توضیحات تکمیلی"
                    v-model="item.explanation"
                    :disabled="!isEditing"
                    rows="3"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <label>اطلاعات پستی</label>
                <v-divider>
                </v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12" md="6">
                <money label="ورن پستی "
                       v-model="item.postal_weight" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="6">
                <money label="طول "
                       v-model="item.length" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12" md="6">
                <money label="عرض "
                       v-model="item.width" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="6">
                <money label="ارتفاع "
                       v-model="item.height" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>


            </v-row>
          </template>
          <template v-else>
            <v-row v-if="item.id">
              <v-col cols="12">
                <v-img
                    @click="change_picture_dialog = true"
                    class="mr-2"
                    style="cursor: pointer"
                    v-if="!item.picture"
                    contain
                    max-height="90"
                    max-width="90"
                    src="/img/icons/product.svg"
                />
                <v-avatar class="mr-2" v-if="item.picture" size="100" style="cursor: pointer"
                          @click="change_picture_dialog = true">
                  <v-img class="rounded-lg" :src="item.picture"/>
                </v-avatar>
              </v-col>
            </v-row>

            <v-row>
              <v-col col="12" md="12">
                <v-text-field label="نام محصول "
                              v-model="item.name" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>
              </v-col>

              <v-col col="12" md="6">
                <v-text-field label="شناسه محصول "
                              v-model="item.product_id" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="6">
                <currency-select
                    class="rounded-lg"
                    label="ارز"
                    v-model="item.currency"
                    :disabled="!isEditing"
                >
                </currency-select>
              </v-col>
              <v-col col="12" md="4">
                <v-text-field label="کد قفسه "
                              v-model="item.shelf_code" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="4">
                <money label="موجودی اولیه "
                       v-model="item.first_inventory" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="4">
                <money label="قیمت "
                       v-model="item.price" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="4">
                <money label="حاشیه سود "
                       v-model="item.profit_percent" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="4">
                <money label="حداقل موجودی "
                       v-model="item.min_inventory" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="4">
                <money label="هزینه حمل و نقل "
                       v-model="item.shipping_cost" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="4">
                <money label="درصد مالیات "
                       v-model="item.tax_percent" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="4">
                <category-select
                    class="rounded-lg"
                    label="دسته بندی"
                    v-model="item.category"
                    :disabled="!isEditing"
                ></category-select>
              </v-col>
              <v-col col="12" md="4">
                <supplier-select
                    class="rounded-lg"
                    label="تامین کننده"
                    v-model="item.supplier"
                    :disabled="!isEditing"
                >
                </supplier-select>
              </v-col>
              <v-col col="12" md="4">
                <brand-select
                    class="rounded-lg"
                    label="برند کالا"
                    v-model="item.brand"
                    :disabled="!isEditing"
                ></brand-select>
              </v-col>
              <v-col col="12" md="4">
                <date
                    class="rounded-lg"
                    label="تاریخ تولید"
                    v-model="item.product_date"
                    :disabled="!isEditing"

                />
              </v-col>
              <v-col col="12" md="4">
                <date
                    class="rounded-lg"
                    label="تاریخ انقضا"
                    v-model="item.expired_date"
                    :disabled="!isEditing"

                />
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                    class="rounded-lg"
                    label="توضیحات مختصر"
                    v-model="item.summary_explanation"
                    :disabled="!isEditing"
                    rows="2"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                    class="rounded-lg"
                    label="نحوه استفاده"
                    v-model="item.how_to_use"
                    :disabled="!isEditing"
                    rows="2"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                    class="rounded-lg"
                    label="توضیحات تکمیلی"
                    v-model="item.explanation"
                    :disabled="!isEditing"
                    rows="3"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <label>اطلاعات پستی</label>
                <v-divider>
                </v-divider>

              </v-col>

              <v-col col="12" md="3">
                <money label="ورن پستی "
                       v-model="item.postal_weight" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="3">
                <money label="طول "
                       v-model="item.length" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="3">
                <money label="عرض "
                       v-model="item.width" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>
              <v-col col="12" md="3">
                <money label="ارتفاع "
                       v-model="item.height" background-color="white" class="rounded-lg"
                       :disabled="!isEditing"/>
              </v-col>

            </v-row>
          </template>
        </m-form>
        <v-row justify="center">
          <v-dialog
              v-model="change_picture_dialog"
              class="rounded-lg"
              persistent
              @click:outside="change_picture_dialog=false"
              max-width="400"
          >
            <v-card class="rounded-lg pa-2">
              <v-card-title class="primary--text text-h5">
                تغییر تصویر محصول
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <m-file-input
                        label="انتخاب تصویر محصول"
                        v-model="picture"
                        :delete-attachment.sync="delete_picture"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    text
                    @click="change_picture_dialog = false"
                >
                  بستن
                </v-btn>
                <v-btn
                    color="success"
                    text
                    @click="updatePicture(item)"
                >
                  تغییر تصویر محصول
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import formsMixin from "@/mixin/forms";
import CurrencySelect from "@/components/selects/CurrencySelect";
import SupplierSelect from "@/components/selects/SupplierSelect";
import CategorySelect from "@/components/selects/CategorySelect";
import BrandSelect from "@/components/selects/BrandSelect";


export default {
  name: "ProductForm",
  mixins: [MFormMixin, formsMixin, FormsMixin],
  components: {BrandSelect, CategorySelect, SupplierSelect, CurrencySelect},
  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'product/product/all',
      isWorkshopConfirmed: false,
      baseUrl: "product/product",
      permissionBasename: "product",
      appendSlash: true,
      hasList: false,
      no_edit_dialog: false,
      change_picture_dialog: false,
      picture: null,
      delete_picture: null,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      items: [],
      first: false,
      cols: [
        {
          text: "شناسه محصول",
          value: "product_id",
        },
        {
          text: "نام محصول",
          value: "name",
          max_length: 100,
        },
      ],


    };
  },
  computed: {
    title() {
      return 'محصول'
    },
    headers() {
    },
  },
  updated() {
  },
  created() {
  },
  methods: {
    getUpdatePictureSerialized(selectItem) {
      let item = {
        id: selectItem.id,
        picture: this.picture,
        delete_picture: this.delete_picture,
      };

      if (typeof item["picture"] == typeof "") {
        delete item["picture"];
      }

      return this.jsonToFormData(item);
    },

    updatePicture(selectItem) {
      this.request({
        url: this.endpoint(`product/productPictureUpdate/${selectItem.id}`),
        method: "put",
        data: this.getUpdatePictureSerialized(selectItem),
        success: (data) => {
          this.successNotify();
          this.isEditing = false;
          this.change_logo_dialog = false
          this.$refs.productForm.$refs.datatable.getDataFromApi()
        },
      });
    },

  },
}
</script>

<style scoped lang="scss"></style>

